/* eslint-disable no-underscore-dangle */
import CookieManager from 'utils/packages/cookieManager';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { Alert, StatusBar, StyleSheet, View } from 'react-native';
import { WebView } from 'utils/packages/webview';
import { useAppDispatch } from 'store/hooks';
import { AppView } from 'design-system';
import { getAdvancedSwitchingResults, getSwitchingResults, } from '../../../../../actions';
import Amplitude from '../../../../../utils/amplitude';
import Sentry from '../../../../../utils/sentry';
const getAYearFromNow = () => {
    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    return aYearFromNow;
};
const AdvancedEnquiry = ({ navigation, route, }) => {
    const dispatch = useAppDispatch();
    const refWebview = useRef(null);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerStyle: {
                backgroundColor: '#4542f8',
            },
        });
    });
    const aYearFromNow = useRef(getAYearFromNow());
    const [cookieString] = useState(() => {
        const { name, value, domain } = route.params.data.webview.cookie;
        return `${name}=${value}; domain=${domain}; origin=/; path=/; version=1; expires=${aYearFromNow.current};`;
    });
    useEffect(() => {
        Amplitude.logEvent('MoneySuperMarket.AdvancedEnquiry');
        const { domain } = route.params.data.webview.cookie;
        CookieManager.setFromResponse(domain, cookieString).then(() => {
            // the cookie is set at the beginning as a safeguard against getting to it too late
            CookieManager.get(domain)
                .then((cookies) => {
                CookieManager.clearAll().then(() => {
                    CookieManager.setFromResponse(domain, cookieString);
                    if (cookies._dtl_cookie_preferences)
                        CookieManager.setFromResponse(domain, `_dtl_cookie_preferences=${cookies._dtl_cookie_preferences.value}; domain=${domain}; origin=/; path=/; version=1; expires=${aYearFromNow.current};`);
                });
            })
                .catch(() => {
                CookieManager.clearAll().then(() => {
                    CookieManager.setFromResponse(domain, cookieString);
                });
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onShouldStartLoadWithRequest = useCallback(({ url }) => {
        if (url && url.includes('emma://enquirycomplete/')) {
            refWebview.current?.stopLoading();
            const splittedValues = url
                .replace('emma://enquirycomplete/', '')
                .split('/');
            const enquiryId = splittedValues[0];
            const partnerId = splittedValues[1];
            const body = { enquiryId, partnerId };
            Promise.resolve(dispatch(getAdvancedSwitchingResults(body))).then((response) => {
                if (response && response.payload) {
                    navigation.replace('EnergyQuotes', {
                        enquiryId: Number(enquiryId),
                    });
                    dispatch(getSwitchingResults(enquiryId));
                }
                return response;
            });
            return false;
        }
        if (url && url.includes('emma://switchingerror')) {
            Alert.alert('Error', 'We have encountered an error in processing this application.');
            Sentry.logError({
                filename: 'AdvancedEnquiry.js',
                message: 'Switching Enquiry Error',
            });
            return false;
        }
        return true;
    }, []);
    const { params } = route;
    const { data } = params;
    const { webview } = data;
    const { url } = webview;
    const INJECTEDJAVASCRIPT = "const meta = document.createElement('meta'); meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=0.99, user-scalable=0'); meta.setAttribute('name', 'viewport'); document.getElementsByTagName('head')[0].appendChild(meta);";
    return (<AppView avoidHeader withFrame={false}>
      <View style={styles.container}>
        <StatusBar barStyle="light-content" animated/>
        <WebView ref={refWebview} source={{
            uri: url,
            headers: {
                Cookie: cookieString,
            },
        }} injectedJavaScript={INJECTEDJAVASCRIPT} originWhitelist={['*']} onShouldStartLoadWithRequest={onShouldStartLoadWithRequest} style={styles.content} sharedCookiesEnabled thirdPartyCookiesEnabled/>
      </View>
    </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#4542f8',
    },
    content: {
        flex: 1,
        backgroundColor: '#4542f8',
    },
});
export default AdvancedEnquiry;
